export default "__VITE_PUBLIC_ASSET__622f301a__"